import React from 'react';
import styled, { css } from 'styled-components';
import { useContentTheme, ConditionalContentThemeProvider } from '../content-theme';
import Card from './card';
import Wrapper from './wrapper';
import Background from '../background/index';

const ColumnBackground = ({ background, children }) => {
  if (!background) {
    return children;
  }
  return (
    <Background $size="flexHeight" {...background}>
      {children}
    </Background>
  );
};

const Column = ({
  columnWidth,
  align,
  justify,
  card,
  order,
  flexDirection,
  offset,
  background,
  children,
  className,
  id,
}) => {
  const { contentTheme } = useContentTheme();
  const hasBackgroundImage = Boolean(background?.image);
  const hasBackgroundColor = Boolean(background?.customColor || background?.color);
  return (
    <Wrapper
      id={id}
      $align={align}
      $justify={justify}
      $columnWidth={columnWidth}
      $flexDirection={flexDirection}
      $order={order}
      $offset={offset}
      className={className}
    >
      <ColumnBackground background={background}>
        {(card || hasBackgroundImage) ? (
          <Card
            $contentTheme={contentTheme}
            $transparent={hasBackgroundImage}
            $backgroundColor={background?.color}
            $customBackgroundColor={background?.customColor}
          >
            <ConditionalContentThemeProvider
              contentTheme={(card && !hasBackgroundColor && contentTheme === 'light') ? 'dark' : contentTheme}
            >
              {children}
            </ConditionalContentThemeProvider>
          </Card>
        ) : children}
      </ColumnBackground>
    </Wrapper>
  );
};

export default styled(Column)`
  ${({ $visibleFrom, theme }) => $visibleFrom && $visibleFrom !== 'always' && css`
    display: none;
    @media all and (min-width: ${theme.breakingpoints[$visibleFrom]}) {
      display: block;
    }
  `}
`;
